import {daUtils} from '../_utils';
import {
    AuthUser,
    AuthLoginOptions,
    OAuthTokenOptions,
    RefreshTokenOptions,
    AuthSignupOptions,
    AuthConfirmSignupOptions,
    AuthPasswordResetOptions,
    AuthConfirmPasswordResetOptions,
} from "../_auth/js";
import {
    IApiResponse,
    IAuthTokenResponse,
    IAuthUriResponse,
    INewPasswordRequest,
    IChangePasswordRequest,
} from "./types";
import {RedirectLoginOptions} from "../_auth/js";
import {API_AUTH_BASE_URI} from "./index";


const API_AUTH_SIGNIN=`${API_AUTH_BASE_URI}/signin/`;
const API_AUTH_GET_AUTH_URL=`${API_AUTH_BASE_URI}/uri/`;
const API_AUTH_GET_AUTH_TOKEN=`${API_AUTH_BASE_URI}/token/`;
const API_AUTH_REFRESH_AUTH_TOKEN=`${API_AUTH_BASE_URI}/refresh/`;
const API_AUTH_SIGNOUT = `${API_AUTH_BASE_URI}/signout/`;
const API_AUTH_SIGNUP = `${API_AUTH_BASE_URI}/signup/`;
const API_AUTH_CONFIRM_SIGNUP = `${API_AUTH_BASE_URI}/signup-confirm/`;
const API_AUTH_PASSWORD_RESET = `${API_AUTH_BASE_URI}/password-reset/`;
const API_AUTH_CONFIRM_PASSWORD_RESET = `${API_AUTH_BASE_URI}/password-reset-confirm/`;
const API_AUTH_NEW_PASSWORD = `${API_AUTH_BASE_URI}/new-password/`;
const API_AUTH_CHANGE_PASSWORD = `${API_AUTH_BASE_URI}/change-password/`;
const API_USER_GROUPS_OAUTH =`${API_AUTH_BASE_URI}/user-groups/`;


const login = async (
    options: AuthLoginOptions): Promise<IApiResponse | undefined> => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_AUTH_SIGNIN;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        // Return the full response to handle both success and challenge cases
        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_auth_token = async (
    options: OAuthTokenOptions): Promise<IAuthTokenResponse | undefined> => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options),
        };
        const url = API_AUTH_GET_AUTH_TOKEN;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp && resp.success === true) {
            return resp.data;
        }
    }
    catch (e: any) {
        // catch network errors
        // and Api errors
        alert(e.message);
    }
}

const get_refresh_auth_token = async (
    options: RefreshTokenOptions,
    auth_token: string | undefined = undefined): Promise<IAuthTokenResponse | undefined> => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options),
        };
        const url = API_AUTH_REFRESH_AUTH_TOKEN;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp && resp.success === true) {
            return resp.data;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_auth_url= async (
    options: RedirectLoginOptions): Promise<IAuthUriResponse | undefined> => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_AUTH_GET_AUTH_URL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp && resp.success === true) {
            const ret_val: IAuthUriResponse = resp.data;
            return ret_val
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const logout = async (
    auth_token: string | undefined = undefined) => {
    // Call remote Logout method
    try {
        const body = { token: auth_token}
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(body),
        };
        const url = API_AUTH_SIGNOUT;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);
    }
    catch (e: any) {
        alert(e.message);
    }
}

const signup = async (
    options: AuthSignupOptions): Promise<IApiResponse | undefined> => {
    // Call remote Signup method
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_AUTH_SIGNUP;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const signup_confirm = async (
    options: AuthConfirmSignupOptions): Promise<IApiResponse | undefined> => {
    // Call remote Signup Confirmation method
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };

        const url = API_AUTH_CONFIRM_SIGNUP;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp ) {
            return resp
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const password_reset = async (
    options: AuthPasswordResetOptions): Promise<IApiResponse | undefined> => {
    // Call remote Signup method
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_AUTH_PASSWORD_RESET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const password_reset_confirm = async (
    options: AuthConfirmPasswordResetOptions): Promise<IApiResponse | undefined> => {
    // Call remote Signup Confirmation method
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };

        const url = API_AUTH_CONFIRM_PASSWORD_RESET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp ) {
            return resp
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const set_new_password = async (
    options: INewPasswordRequest): Promise<IApiResponse | undefined> => {
    // Call remote set new password method (for first login with temp password)
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };

        const url = API_AUTH_NEW_PASSWORD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const change_password = async (
    options: IChangePasswordRequest,
    auth_token: string | undefined = undefined)=> {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_AUTH_CHANGE_PASSWORD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        throw e;
    }
}

const get_user_groups_oauth = async (
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const url = API_USER_GROUPS_OAUTH;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

export const authenticationApi = {
    login,
    logout,
    get_auth_url,
    get_auth_token,
    get_refresh_auth_token,
    signup,
    signup_confirm,
    password_reset,
    password_reset_confirm,
    set_new_password,
    change_password,
    get_user_groups_oauth,
};